export default function ConfirmModal({ show, title, message, onConfirm, onCancel, confirmLabel = 'Confirmar', cancelLabel = 'Cancelar', variant = 'danger' }) {
  if (!show) return null
  const btnColors = variant === 'danger'
    ? 'bg-rose-600 hover:bg-rose-500'
    : 'bg-emerald-600 hover:bg-emerald-500'
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-xl border border-white/15 bg-slate-900 p-6 shadow-2xl">
        <h3 className="mb-2 text-base font-semibold text-slate-100">{title}</h3>
        <p className="mb-6 text-sm text-slate-300">{message}</p>
        <div className="flex justify-end gap-3">
          <button onClick={onCancel} className="rounded-lg border border-white/20 px-4 py-2 text-sm text-slate-200 hover:bg-white/10">{cancelLabel}</button>
          <button onClick={onConfirm} className={`rounded-lg px-4 py-2 text-sm font-semibold text-white ${btnColors}`}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  )
}
